import {
    ON_START_GET_PROSPEKT_ORGNR,
    ON_GET_PROSPEKT_ORGNR,
    ON_ERROR_GET_PROSPEKT_ORGNR,    
    ON_START_GET_PROSPEKT_USER_HEADER,
    ON_GET_PROSPEKT_USER_HEADER,
    ON_ERROR_GET_PROSPEKT_USER_HEADER,
    ON_START_GET_PROSPEKT_USER,
    ON_START_GET_PROSPEKT_USER_START,
    ON_GET_PROSPEKT_USER,
    ON_ERROR_GET_PROSPEKT_USER,
    ON_UPDATE_PROSPEKT_FAS,
    ON_ERROR_UPDATE_PROSPEKT_FAS,
    ON_START_UPDATE_PROSPEKT_FAS,
    ON_START_GET_PROSPEKT_FASPAGE_USER,
    ON_GET_PROSPEKT_FASPAGE_USER,
    ON_ERROR_GET_PROSPEKT_FASPAGE_USER,
    ON_START_GET_FORSALJING_ORGNR,  ON_GET_FORSALJING_ORGNR,  ON_ERROR_GET_FORSALJING_ORGNR,
    ON_START_GET_PROSPEKT_USER_NEW,ON_GET_PROSPEKT_USER_NEW,FETCH_START_SET_UNAUTHE,
    ON_START_MESSAGE_KUND,  ON_MESSAGE_KUND,  ON_ERROR_MESSAGE_KUND,
    ON_START_BUFFER_PROSPEKT_FAS,ON_ERROR_BUFFER_PROSPEKT_FAS,ON_BUFFER_PROSPEKT_FAS,
    ON_NEW_AF_PROSPEKT_TASK,
    ON_START_NEW_AF_PROSPEKT_TASK,
    ON_ERROR_NEW_AF_PROSPEKT_TASK,
    ON_UPDATE_AF_PROSPEKT_TASK,
    ON_START_UPDATE_AF_PROSPEKT_TASK,
    ON_ERROR_UPDATE_AF_PROSPEKT_TASK,
    ON_DELETE_AF_PROSPEKT_TASK,
    ON_START_DELETE_AF_PROSPEKT_TASK,
    ON_ERROR_DELETE_AF_PROSPEKT_TASK,
    ON_GET_AF_PROSPEKT_TASK,
    ON_START_GET_AF_PROSPEKT_TASK,
    ON_ERROR_GET_AF_PROSPEKT_TASK,
    ON_GET_CHANGE_PROSPEKT_VY,ON_GET_CHANGE_PROSPEKT_VY_SORT,
    ON_START_GET_PROSPEKTLIST_USER,ON_GET_PROSPEKTLIST_USER,ON_ERROR_GET_PROSPEKTLIST_USER,
    ON_START_UPDATE_PROSPEKT_DEADLINE,ON_UPDATE_PROSPEKT_DEADLINE,ON_ERROR_UPDATE_PROSPEKT_DEADLINE,
    ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY,
  } from "../constants/ActionTypes";
import axios from 'util/Api'
import { isUndefined } from "lodash";
import {userSignOut} from 'actions'
import {RefreshUserInterface} from 'actions'
import { translate } from "../util/intlHelper";

const getClientIp = async () => {
  let Ipadress='0.0.0.0'
  /*
    await fetch('https://geolocation-db.com/json/')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.IPv4});*/
      return Ipadress
}

//getProsprktByOrgnr
export const getProsprktByOrgnr = (userid,Afid,Orgnr,type,page,searchWord) =>{
  let Page = isUndefined(page)?0:page
  let SearchWord = isUndefined(searchWord)?'':searchWord
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_GET_PROSPEKT_ORGNR});
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Prospect.fetchingAll") });
      axios.get('kontos/Prospekt/getByOrgnr',
      { params:{Orgnr:Orgnr,Afid:Afid,userid:userid,page:Page,type:type,SearchWord:SearchWord,ipAdress}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("getProsprktByOrgnr: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_PROSPEKT_ORGNR, payload: data.results});
           dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Prospect.fetchAll")});
         } else {
           dispatch({type: ON_ERROR_GET_PROSPEKT_ORGNR, payload: data.error});
           dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Prospect.fetchAll")});
         }
         dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_PROSPEKT_ORGNR, payload: error.message});
         dispatch({type: ON_ERROR_MESSAGE_KUND,payload:translate("Error.Prospect.fetchAll")});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
    }
  }
//getForsaljningByOrgnr
export const getForsaljningByOrgnr = (userid,Afid,Orgnr,page,seachWord) =>{
  let Page = isUndefined(page)?0:page
  let SeachWord = isUndefined(seachWord)?'':seachWord
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_GET_FORSALJING_ORGNR});
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Sales.fetching")});
      
      axios.get('kontos/Forsaljning/getByOrgnr',
      { params:{Orgnr:Orgnr,Afid:Afid,userid:userid,page:Page,SeachWord:SeachWord,ipAdress}, 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then(({data}) => {
        console.log("getForsaljningByOrgnr: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_GET_FORSALJING_ORGNR, payload: data.results});
           dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Sales.fetch")});
         } else {
           dispatch({type: ON_ERROR_GET_FORSALJING_ORGNR, payload: data.error});
           dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Sales.fetch")});
         }
         dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_GET_FORSALJING_ORGNR, payload: error.message});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Sales.fetch")});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE, payload: translate("Error.Sales.fetch")});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
       });
    }
  }
  
  
 //getProspetByUserIdHeader
 export const getProspetByUserIdHeader = (Afid,userid,type,Filterstate) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_PROSPEKT_USER_HEADER});
    axios.get('kontos/Prospekt/getByUserHeadar',
    { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      Filterstate:Filterstate,ipAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProspetByUserIdHeader: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_PROSPEKT_USER_HEADER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROSPEKT_USER_HEADER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROSPEKT_USER_HEADER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getProspektByUserid1
export const getProspektByUserid1 = (Afid,userid,type,Filterstate) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
      dispatch({type: ON_START_GET_PROSPEKT_USER_NEW});
    axios.get('kontos/Prospekt/getByUser',
    { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      Filterstate:Filterstate,ipAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProspektByUserid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_PROSPEKT_USER_NEW, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROSPEKT_USER, payload: data.error});
       }
       
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROSPEKT_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getProspektListByUserid

export const getProspektListByUserid = (Afid,userid,type,page,pageRow,Filterstate,searchWord,SortObj,Start) =>{
  const jwt =  JSON.parse(localStorage.token);
  let isStart = isUndefined(Start)?0:1
  searchWord = isUndefined(searchWord)?"":searchWord
  return async (dispatch) => {
    dispatch({type: ON_START_GET_PROSPEKTLIST_USER});
    axios.get('kontos/Prospekt/getListByUser',
    { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      page:page,
      pageRow:pageRow,
      Filterstate:Filterstate,
      SortObj:SortObj,
      searchWord
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProspektByUserid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_PROSPEKTLIST_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROSPEKTLIST_USER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROSPEKTLIST_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });

  }
}
//getProspektByUserid
export const getProspektByUserid = (Afid,userid,type,Filterstate,searchWord,Start) =>{
  const jwt =  JSON.parse(localStorage.token);
  let isStart = isUndefined(Start)?0:1
  searchWord = isUndefined(searchWord)?"":searchWord
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    if(Start === 1){
      dispatch({type: ON_START_GET_PROSPEKT_USER_START});
    }
    else{
      dispatch({type: ON_START_GET_PROSPEKT_USER});
    }
    axios.get('kontos/Prospekt/getByUser',
    { params:{
      Afid:Afid,
      userid:userid,
      type:type,
      Filterstate:Filterstate,ipAdress,searchWord
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProspektByUserid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_PROSPEKT_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROSPEKT_USER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROSPEKT_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//updatePropspektFas
export const updatePropspektFas = (prospektId,SourceFasid,TargetFasid,Afid,userid,Filterstate,searchWord, UpdateProbability = 0) =>{
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_PROSPEKT_FAS});
      axios.put('kontos/Prospekt/updateFas', {
       body: {
         Afid:Afid,
         userid:userid,
         prospektId:prospektId,
         SourceFasid:SourceFasid,
         TargetFasid:TargetFasid,searchWord,
         Filterstate:Filterstate,ipAdress,UpdateProbability
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updatePropspektFas: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_PROSPEKT_FAS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_PROSPEKT_FAS, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_PROSPEKT_FAS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
export const updatePropspektFasV2 = (prospektId,SourceFasid,TargetFasid,Afid,userid,Filterstate,searchWord, UpdateProbability = 0) =>{
  searchWord = isUndefined(searchWord)?"":searchWord
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_PROSPEKT_FAS});
      axios.put('kontos/Prospekt/updateFas', {
       body: {
         Afid:Afid,
         userid:userid,
         prospektId:prospektId,
         SourceFasid:SourceFasid,
         TargetFasid:TargetFasid,searchWord,
         Filterstate:Filterstate,ipAdress,UpdateProbability
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updatePropspektFas: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          // dispatch({type: ON_UPDATE_PROSPEKT_FAS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_PROSPEKT_FAS, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_PROSPEKT_FAS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //getProspektByUseridFasPage
 export const getProspektByUseridFasPage = (userid,Afid,page,fas,Filterstate,type,searchWord) =>{
  page = isUndefined(page)?0:page;
  searchWord = isUndefined(searchWord)?0:searchWord;
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_PROSPEKT_FASPAGE_USER});
    await axios.get('kontos/Prospekt/Fas/getByUser',
    { params:{
      Afid:Afid,
      userid:userid,
      page:page,
      Filterstate:Filterstate,
      type:type,searchWord,
      fas:fas,ipAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProspektByUseridFasPage: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_PROSPEKT_FASPAGE_USER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROSPEKT_FASPAGE_USER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROSPEKT_FASPAGE_USER, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 export const bufferProspektByUseridFasPage = (userid,Afid,page,fas,Filterstate,type,searchWord) =>{
  page = isUndefined(page)?0:page;
  searchWord = isUndefined(searchWord)?0:searchWord;

  

  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_BUFFER_PROSPEKT_FAS});
    await axios.get('kontos/Prospekt/Fas/getByUser',
    { params:{
      Afid:Afid,
      userid:userid,
      page:page,
      Filterstate:Filterstate,
      type:type,searchWord,
      fas:fas,ipAdress
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getProspektByUseridFasPage: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_BUFFER_PROSPEKT_FAS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_BUFFER_PROSPEKT_FAS, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BUFFER_PROSPEKT_FAS, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

 export const getAfProspektTask = (Userid,Afid) =>{

  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AF_PROSPEKT_TASK});
    await axios.get('kontos/Prospekt/Task/getAfProspektTask',
    { params:{
      Afid:Afid,
      Userid:Userid,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAfProspektTask: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AF_PROSPEKT_TASK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AF_PROSPEKT_TASK, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AF_PROSPEKT_TASK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
 export const deleteAfProspektTask = (Userid, Afid, TaskId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_DELETE_AF_PROSPEKT_TASK});
    await axios.delete('kontos/Prospekt/Task/deleteAfProspektTask',
    { params:{
      Afid, Userid, TaskId
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("deleteAfProspektTask: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_DELETE_AF_PROSPEKT_TASK, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_DELETE_AF_PROSPEKT_TASK, payload: data.error});
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_DELETE_AF_PROSPEKT_TASK, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const updateAfProspektTask = (Userid, Afid, Task) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_AF_PROSPEKT_TASK});
      axios.put('kontos/Prospekt/Task/updateAfProspektTask', {
       body: {
          Afid, Userid, Task
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfProspektTask: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_AF_PROSPEKT_TASK, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_AF_PROSPEKT_TASK, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_AF_PROSPEKT_TASK, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
export const updateAfProspektTaskOrder = (Userid, Afid, Tasks) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_AF_PROSPEKT_TASK});
      axios.put('kontos/Prospekt/Task/updateAfProspektTaskOrder', {
       body: {
          Afid, Userid, Tasks
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfProspektTaskOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_AF_PROSPEKT_TASK, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_AF_PROSPEKT_TASK, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_AF_PROSPEKT_TASK, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
export const createNewAfProspektTask = (Userid, Afid, Task) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_NEW_AF_PROSPEKT_TASK});
      axios.post('kontos/Prospekt/Task/createNewAfProspektTask', {
       method: 'POST',
       body: {
          Afid, Userid, Task
       }
      },{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfProspektTask: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_AF_PROSPEKT_TASK, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_NEW_AF_PROSPEKT_TASK, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_AF_PROSPEKT_TASK, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//onChangeProspektVyn
export const onChangeProspektVyn = (prospektVyn) => {
  return (dispatch) => {
    localStorage.setItem("prospektVyn", JSON.stringify(prospektVyn));
    dispatch({type: ON_GET_CHANGE_PROSPEKT_VY, payload: {prospektVyn:prospektVyn}});
   }
}
export const setProspektSort = (nSortObj) => {
  return (dispatch) => {
    localStorage.setItem("ProspektSortObj", JSON.stringify(nSortObj));
    dispatch({type: ON_GET_CHANGE_PROSPEKT_VY_SORT, payload: {prospektVyn:nSortObj}});
   }
}

//onUpdateProspektDeadline
export const onUpdateProspektDeadlineP = (Afid ,userid,ProspektID,deadline,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_PROSPEKT_DEADLINE});
      axios.put('kontos/Prospekt/deadline/update', {
       body: {
          Afid, userid, ProspektID,deadline
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      },{
        'content-type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
    } ).then(({data}) => {
       console.log("updateAfProspektTaskOrder: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_PROSPEKT_DEADLINE, payload: data.results});
          if(callBackFunc){callBackFunc()}
        } else {
          dispatch({type: ON_ERROR_UPDATE_PROSPEKT_DEADLINE, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_PROSPEKT_DEADLINE, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//onGetProspektSummary
export const onGetProspektSummary = (userid,Afid,AvtalId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY});
    await axios.get('kontos/Prospekt/Kalkyl/summary',
    { params:{
      Afid:Afid,
      userid:userid,
      AvtalId:AvtalId,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("onGetProspektSummary: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY, payload: data.error});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_PROSPEKT_PROSPEKT_KALKYL_SUMMARY, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const onGetAvtalOrgnr = (AvtalId,callBackFunc) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    await axios.get('kontos/Prospekt/orgnr',
    { params:{
      AvtalId:AvtalId,
    }, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        callBackFunc(data.results)
       } else {
        console.log(data.error)
       }
     }).catch(function (error) {
      console.log(error)
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
